import { CameraFile } from "@/domain/contracts";
import { z } from "zod";

export const CameraFileSchema: z.ZodType<CameraFile> = z.object({
  uri: z.string(),
  type: z.string(),
  name: z.string(),
  key: z.string().optional(),
  size: z.union([z.number(), z.undefined()]),
});
